import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Catalog } from "@/components/Catalog";
import { Footer } from "@/components/Footer";
import { BASE_PRODUCTS } from "@/data/products";
import { fetchCustomItems } from "@/lib/api";

export default function HomePage() {
  const [customItems, setCustomItems] = useState([]);

  useEffect(() => {
    document.title = "Findora | Stylely by Daden — Household, Clothing & Gadgets Picks";
    fetchCustomItems()
      .then((items) =>
        setCustomItems(
          items.map((it) => ({
            code: it.code,
            name: it.name,
            category: it.category,
            price: it.price || null,
            rating: it.rating ?? null,
            ratingsCount: it.ratings_count ?? null,
            amazonUrl: it.amazon_url,
            takeaway: it.takeaway || null,
            image: it.image || null,
            isNew: true,
          }))
        )
      )
      .catch(() => {});
  }, []);

  const allItems = [...BASE_PRODUCTS, ...customItems];

  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero count={allItems.length} />
        <Marquee />
        <Catalog items={allItems} />
      </main>
      <Footer />
    </div>
  );
}
